import { gql } from '@apollo/client';
const ADD_PRODUCT_EVENT = gql `
  mutation AddProductEvent($name: String!, $description: String, $thumbnail: String) {
    addProductEvent(name: $name, description: $description, thumbnail: $thumbnail) {
      productEvent {
        id
        name
        description
        thumbnail
      }
    }
  }
`;
export default ADD_PRODUCT_EVENT;
